import React, {createContext, useEffect, useState} from 'react';
import {getCart} from "../app/common/api/PortalCustomerApi";

export const CartContext = createContext({
  reloadCart: true,
  viewCart: false,
  invoice: null,
  cartItems: [],
  cartOpen: false,
  caller: ''
});

export const CartProvider = (props) => {
  const [context, setContext] = useState({
    reloadCart: true,
    viewCart: false,
    invoice: null,
    cartOpen: false,
    cartItems: [],
    caller: ''
  });

  useEffect(() => {
    if (!context.reloadCart && context.invoice) {
      return;
    }
    getCart().then((resp)=> {
      if (context?.cartOpen) {
        return;
      }
      setContext({...context, cartOpen: true, cartItems: resp?.items, caller:'self', reloadCart: false});
    });
  }, [context.reloadCart]);

  return (
    <CartContext.Provider value={[context, setContext]}>
      {props.children}
    </CartContext.Provider>
  )
}